module.exports = __webpack_public_path__ + "static/media/Apartment-7@2x.9d489e6c.png";